<template lang="pug">
.nuxt-error.page.error(:data-code="error.statusCode")
  .wrapper
    .container
      empty(
        :title="title"
        :description="description"
        :type="type")
        .actions
          a.linked(href="#" @click.prevent="back") ← Back
          landing-link.linked(path="/") Homepage
          nuxt-link.linked(:to="linkToDashboard" v-if="linkToDashboard") Dashboard
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  layout: 'landing',

  scrollToTop: true,

  props: {
    error: {
      type: Object,
      default: () => {}
    }
  },

  head () {
    return {
      title: this.title
    }
  },

  computed: {
    ...mapGetters({
      toDashboard: 'authentication/toDashboard',
      isVendor: 'authentication/isVendor',
      isVendorAdmin: 'authentication/isVendorAdmin',
      vendorPermissionRoutes: 'authentication/vendorPermissionRoutes'
    }),

    linkToDashboard () {
      if (!this.isVendor ||
        this.isVendorAdmin ||
        this.vendorPermissionRoutes.includes(this.toDashboard?.name))
        return this.toDashboard

      return { name: this.vendorPermissionRoutes[0] || 'vendors-settings' }
    },

    title () {
      switch (this.error.statusCode) {
        case 503:
          return 'Temporary Unavailable'
        case 403:
        case 404:
        default:
          return 'Uh-oh...'
      }
    },

    description () {
      switch (this.error.statusCode) {
        case 403:
          return 'You are not authorized to access this page. Please contact your administrator for assistance.'
        case 404:
          return 'Look like this page is missing...'
        case 503:
          return 'The page you\'re trying to access is temporary unavailable... Please try again later.'
        default:
          return 'Unexpected error...'
      }
    },

    type () {
      return this.error.statusCode
    }
  },

  methods: {
    back () {
      if (this.$nuxt?.context?.from)
        this.$router.back()

      this.$router.push({ name: 'index' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page.error {
  min-height: calc(80vh - 92px);
  display: flex;
  align-items: center;
  background: white;
  .wrapper {
    flex: 1;
  }
  .actions {
    text-align: center;
    > * {
      margin: .25em .75em;
    }
  }
}
</style>
